module.exports = __webpack_public_path__ + "static/NW_Lucas_Bild_Lands_1-9ddc7e85a2f46431fcbe4e9602c0c039.jpg";